'use client';

import { css } from '@bts-web/utils-style-engine';
import { FC } from 'react';
import { getAppConfig } from '@bts-web/core-app-config';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { HTMLRenderer } from '@bts-web/core-features/common';

const successBuySubtitlesStyles = css({
  fontSize: 'body.medium',
  color: 'neutrals.text_secondary',
  '& [data-element="markdown-style"]': {
    color: 'neutrals.text_primary',
    whiteSpace: 'nowrap',
  },
  '& [data-element="additional-text-style"]': {
    color: 'neutrals.text_primary',
  },
});

export const SuccessBuyContent: FC<{
  subtitleMessage: string;
  nowAvailableMessage: string;
}> = ({ subtitleMessage, nowAvailableMessage }) => {
  const { t } = useClientTranslation();

  const { additionalBuyConfirmationText } = getAppConfig();

  const lbbwAdditionalLine = additionalBuyConfirmationText
    ? t(additionalBuyConfirmationText as any)
    : null;

  return (
    <div
      data-testid="tradeSuccessBuyMessage"
      aria-label="trade success buy message"
      className={css({
        gap: 'medium',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      })}
    >
      <p className={successBuySubtitlesStyles}>
        <HTMLRenderer>{subtitleMessage}</HTMLRenderer>
      </p>
      <span className={successBuySubtitlesStyles}>
        <HTMLRenderer>{nowAvailableMessage}</HTMLRenderer>
      </span>
      {lbbwAdditionalLine ? (
        <span data-element="additional-text-style">{lbbwAdditionalLine}</span>
      ) : null}
    </div>
  );
};
